<template>
  <div class="loading-warp">
    <!-- <loading color="white" size="60px"></loading> -->

    <div class="van-loading">
      <div class="loader-home">Loading...</div>
    </div>
  </div>
</template>

<script>
// import { Loading } from 'vant'
export default {
  components: {
    // Loading
  },
  data() {
    return {};
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
  watch: {}
};
</script>

<style lang="less" scoped>
.loading-warp {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 301;
  display: flex;
  justify-content: center;
  align-items: center;
  background: transparent;
  .van-loading {
    position: relative;
    width: 70px;
    height: 70px;
    padding: 10px;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.5);
  }
}

.loader-home {
  width: 50px;
  height: 50px;
  font-size: 2px;
  position: absolute;
  text-indent: -9999em;
  top: 50%;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  border-top: 3px solid rgba(255, 255, 255, 0.6);
  border-right: 3px solid rgba(255, 255, 255, 0.6);
  border-bottom: 3px solid rgba(255, 255, 255, 0.6);
  border-left: 3px solid rgba(0, 0, 0, 0.6);
  transform: translateZ(0);
  animation: loadinghome 0.7s infinite linear;
}
.loader-home,
.loader-home:after {
  border-radius: 50%;
  width: 50px;
  height: 50px;
}
@keyframes loadinghome {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
